import styled from "styled-components";

export const ExpandableContentRoot = styled.div`
    padding: 10px;
`;
